<!-- components/EditForm.vue -->
<template>
  <div class="edit-form">
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="名称" prop="value">
        <el-input v-model="form.value" :disabled="isView"></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="form.address" :disabled="isView"></el-input>
      </el-form-item>
      <el-form-item label="审核说明" v-if="form.models=='审核'" prop="info">
        <el-input v-model="form.info"></el-input>
      </el-form-item>
      <div class="button-div">
        <el-button type="primary" @click="saveData" v-if="form.models=='编辑'||form.models=='新增'">保存</el-button>
        <el-button type="primary" @click="submitAndRelease" v-if="form.models=='编辑'||form.models=='新增'">保存并发布</el-button>
        <el-button type="success" @click="approved" v-if="form.models=='审核'">审核通过</el-button>
        <el-button type="danger" @click="unapproved" v-if="form.models=='审核'">审核不通过</el-button>
        <el-button @click="$emit('close')">关闭</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'reportEditPage',
  props: {
    data: { type: Object, required: true },
    isView: { type: Boolean, default: false }
  },
  data() {
    return {
      form: { ...this.data }, // 复制数据避免直接修改 props
      rules: {
          value: [
            { required: true, message: '请输入店铺名称', trigger: 'blur' },
            { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
          ],
          address: [
            { required: true, message: '请输入店铺地址', trigger: 'blur' }
          ],
          info: [
            { required: true, message: '请输入审核说明', trigger: 'blur' }
          ]
        }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(valid => {
          if (valid) {
            console.log("准备保存数据",this.form);
            this.$emit('save', this.form);
          } else {
            this.$messageX.xiaoxiti('w', "请按照要求输入内容！");
            return false;
          }
      });
    },
    saveData() {
      this.form.types = '待处理';
      this.submit();
    },
    submitAndRelease() {
      this.form.types = '审核中';
      this.submit();
    },
    approved() {
      this.form.types = '已上架';
      this.submit();
    },
    unapproved() {
      this.form.types = '审核不通过';
      this.submit();
    }
  }
}
</script>

<style scoped>
.edit-form input {
  display: block;
  margin-bottom: 10px;
  padding: 6px;
}

.button-div {
  margin-left: 80px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 18px;
}
</style>